import HTTP from "../http";
import Jsona from "jsona";
import user from "@/store/modules/user";
import { setUser, captureException } from "@sentry/browser";

const dataFormatter = new Jsona();

export default {
  async searchByAccountId(id) {
    try {
      let results = await HTTP.normal.get(
        `/accounts/${id}?include=accountable,profile,payment_gateway_account.wallet,phones,accounts_terms_of_uses,chat_session`
      );
      return dataFormatter.deserialize(results.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar o usuário.";
    }
  },

  async updateProfilePicture(profile_picture) {
    try {
      let data = {
        data: {
          type: "profiles",
          id: user.state.user.profile.id,
          attributes: {
            profile_picture
          }
        }
      };

      await HTTP.normal.patch(`/profiles/${user.state.user.profile.id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar a foto de perfil.";
    }
  },

  async updateAccount(attributes) {
    try {
      const id = user.state.user.id;

      const data = {
        data: {
          type: "accounts",
          id,
          attributes
        }
      };

      await HTTP.normal.patch(`/accounts/${id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar a conta.";
    }
  },

  async updateProfile(attributes) {
    try {
      const id = user.state.user.profile.id;

      const data = {
        data: {
          type: "profiles",
          id,
          attributes
        }
      };

      await HTTP.normal.patch(`/profiles/${id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar o perfil.";
    }
  },

  async updatePhone(attributes) {
    try {
      const id = user.state.user.phones[0].id;

      const data = {
        data: {
          type: "phones",
          id,
          attributes
        }
      };

      await HTTP.normal.patch(`/phones/${id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar o telefone.";
    }
  },

  async sendEmailVerification() {
    try {
      let { id } = user.state.user;
      await HTTP.normal.post(`/email-verification/send`, {
        data: { id, type: "accounts" }
      });
    } catch (e) {
      throw "Ocorreu um erro ao enviar a verificação de email.";
    }
  },

  async verifyEmail(token) {
    try {
      let data = {
        data: {
          type: "email_verification_token",
          attributes: {
            token
          }
        }
      };

      await HTTP.normal.post(`/email-verification/verify`, data);
    } catch (e) {
      throw "Ocorreu um erro ao verificar o email.";
    }
  },

  async sendPasswordRecovery(email) {
    try {
      let data = {
        email: email.toLowerCase()
      };
      await HTTP.normal.post(`/password-recovery`, data);
    } catch (e) {
      throw e.response.status === 404
        ? "Não conseguimos encontrar o email informado!"
        : "Ocorreu um erro ao enviar o email!";
    }
  },

  async sendPasswordReset(payload) {
    try {
      let { email, password, password_confirmation, token } = payload;

      let data = {
        email: email.toLowerCase(),
        password,
        password_confirmation
      };

      await HTTP.normal.post(`/password-recovery/${token}`, data);
    } catch (e) {
      setUser({ email: payload.email });
      captureException(e);
      if (e.response.status === 404)
        throw "Ops! O email informado não confere com o token!";
      else if (e.response.status === 400)
        throw "Ops! O link para redefinir sua senha expirou. Solicite um novo abaixo.";
      else throw "Ocorreu um erro ao redefinir a senha!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/user.js